import { Checkbox, Flex, FlexProps, HStack, TextProps } from "@chakra-ui/react";
import { Text } from "./Text";
import React, { ReactNode, useMemo, useState } from "react";

interface DisplayTaxIDProps extends FlexProps {
  value: string;
  label?: string | ReactNode;
  maskByDefault?: boolean;
  labelProps?: TextProps;
}

export const DisplayTaxID = ({
  value,
  label = "SSN",
  maskByDefault = true,
  labelProps = {},
  ...rest
}: DisplayTaxIDProps) => {
  const [masked, setMasked] = useState<boolean>(maskByDefault);
  const text = useMemo(() => {
    if (masked && value) {
      if (value.length <= 4) {
        return "*".repeat(value.length);
      }
      const last4 = value.slice(-4);

      // Always show fixed 5 asterisks plus last 4 characters for consistency
      return `*****${last4}`;
    }

    return value;
  }, [masked, value]);

  return (
    <Flex direction="column" mt="1" {...rest}>
      <HStack mr={6}>
        <Text mb="0" {...labelProps}>
          {label}:
        </Text>
        <Text wordBreak="break-all" maxW="full" className="fvMask">
          {text}
        </Text>
      </HStack>

      <Checkbox
        onChange={() => {
          setMasked((prev) => !prev);
        }}
        checked={!masked}>
        Show {label}
      </Checkbox>
    </Flex>
  );
};
